module.exports = __webpack_public_path__ + "static/media/conway_claim_small.161e368e.jpg";